import { isFeatureEnabled } from 'owa-feature-flags';
import { isMorningBriefing, isEveningBriefing } from './currentTimeCheckUtils';
/**
 * Checks if the inbox briefing SUA should be shown based on feature flight and current time.
 * @returns true if inbox briefing should be displayed
 */
export function shouldShowInboxBriefingsSUA(): boolean {
    return (
        isFeatureEnabled('mon-copilot-inbox-briefings') &&
        (isMorningBriefing() || isEveningBriefing())
    );
}
